const antiquityEconomicActivityTimeRanges = [
    '0-6 meses',
    '6-12 meses',
    '12-24 meses',
    '24 meses o más'
]

export default antiquityEconomicActivityTimeRanges;